export interface FAQ {
  question: string;
  answer: string;
}

export const faqs: FAQ[] = [
  {
    question: '韩漫画网站上的漫画都是免费的吗？',
    answer: '是的，韩漫画网站上的所有韩国漫画均支持免费阅读。我们致力于为广大漫画爱好者提供高质量的免费韩漫资源，无需付费即可畅享下拉式阅读体验。我们会持续更新最新章节，让您第一时间追更喜爱的漫画作品。',
  },
  {
    question: '什么是下拉式漫画阅读？',
    answer: '下拉式阅读是韩漫特有的一种阅读方式，漫画内容以垂直长条形式呈现，您只需向下滑动页面即可连续阅读，无需翻页。这种方式完美适配手机和电脑屏幕，让阅读体验更加流畅自然，是目前最受欢迎的韩漫阅读方式。',
  },
  {
    question: '韩漫画的更新频率是怎样的？',
    answer: '我们会根据原作连载进度同步更新漫画章节。大多数热门韩漫每周更新一次，部分连载作品可能双周更新。网站首页会实时展示最新更新的漫画，您可以通过"最近更新"栏目快速找到最新内容。',
  },
  {
    question: '如何找到想看的韩国漫画？',
    answer: '您可以通过多种方式找到心仪的韩漫：使用顶部的搜索框直接搜索漫画名称；通过分类导航（浪漫爱情、奇幻冒险、动作热血等）浏览特定类型的作品；在首页的"热门推荐"中查看最受欢迎的漫画；或者查看"最近更新"获取最新连载内容。',
  },
  {
    question: '韩漫画可以在手机上阅读吗？',
    answer: '当然可以！我们的网站采用了响应式设计，完美适配手机、平板和电脑等各种设备。无论您使用什么设备访问，都能获得流畅的下拉式阅读体验。您可以将网站添加到手机主屏幕，像使用App一样随时阅读喜欢的韩漫。',
  },
  {
    question: '漫画加载速度慢怎么办？',
    answer: '我们采用了先进的图片优化和CDN加速技术，确保漫画图片能够快速加载。如果您遇到加载缓慢的情况，建议检查网络连接状态，或尝试切换到更稳定的网络环境。您也可以在页面加载完成后开始阅读，后续章节会在后台自动预加载。',
  },
];